import { render, staticRenderFns } from "./ManageList.vue?vue&type=template&id=7d4845ca&"
import script from "./ManageList.vue?vue&type=script&lang=js&"
export * from "./ManageList.vue?vue&type=script&lang=js&"
import style0 from "./ManageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports